import React, { useEffect, useState } from "react";
import Select from "react-select";
import PropTypes from "prop-types"; // Import PropTypes
import { Button, Form, Modal } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { COLOR_APP } from "../../../constants";
import { useMutation } from "@apollo/client";
import {
  CREATE_SHOP_COMMISION_INFLUENCER,
  UPDATE_COMMISION_INFLUENCER,
} from "../../../graphql/influencer/mutation";
import { useToasts } from "react-toast-notifications";

function InfulancerForm({
  showForm,
  hanldeClose,
  inFluData,
  shopId,
  fetchcommissionData,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const { addToast } = useToasts();

  const [preData, setPreData] = useState({
    commission: "",
    note: "",
  });

  const [createLinkForInflue, { loading: createLinkLoading }] = useMutation(
    CREATE_SHOP_COMMISION_INFLUENCER
  );
  const [updateCommissionInflue, { loading: updateLoading }] = useMutation(
    UPDATE_COMMISION_INFLUENCER
  );

  // ກວດສອບເບິ່ງວ່າ ຖ້າຂໍ້ມູນເປັນໂມດແກ້ໄຂ ໃຫ້ເປັນຟອມແກ້ໄຂ ນອກຈາກນັ້ນ ໃຫ້ເປັນ ຟອມບັນທຶກ
  useEffect(() => {
    if (showForm?.editMode && showForm?.data) {
      setPreData({
        commission: showForm?.data.commission,
        note: showForm?.data?.note,
      });
      setSelectedOption({
        label: showForm?.data?.shop_name,
        value: showForm?.data?.id,
      });
    } else {
      setPreData({
        commission: "",
        note: "",
      });
      setSelectedOption(null);
    }
  }, [showForm?.editMode, showForm?.data]);

  // ເກັບຄ່າຊື່ ແລະ ໄອດີ ຂອງອິນຟຮູເເລນເຊີ
  const handleChange = (option) => {
    setSelectedOption(option);
    // setFilter({shop: option?.value})
  };

  // ດືງຂໍ້ມູນຂອງ ອິນຟຣູແລນເຊີ
  const options = inFluData?.data
    ? inFluData?.data.map((item) => ({
        value: item?.id,
        label: item?.first_name + " " + item?.last_name,
      }))
    : [];

    // ຟັງເຊິນສ້າງລິ້ງໃຫ້ສຳລັບ ອິນຟຣູແລນເຊີ
  const handleCreateLinkInfluencer = async (e) => {
    e.preventDefault();
    try {
      if (createLinkLoading) return;

      // mode edit -------------------------------------------------->
      if (showForm?.editMode && showForm?.data) {
        const resEdit = await updateCommissionInflue({
          variables: {
            data: {
              commission: parseFloat(preData?.commission),
              // infulancer: selectedOption?.value,
              shop_name: selectedOption?.label,
              note: preData?.note,
              shop: shopId,
              type: "NORMAL",
            },
            where: {
              id: showForm?.data?.id,
            },
          },
        });

        if (resEdit) {
          addToast("ແກ້ໄຂຄ່າຄອມມິດຊັ່ນ ສຳລັດແລ້ວ", {
            appearance: "success",
            autoDismiss: true,
          });
          hanldeClose();
          fetchcommissionData();
          setPreData({
            commission: "",
            note: "",
          });
          setSelectedOption(null);
        }
      } 
      // mode create -------------------------------------------------->
      else {
        const res = await createLinkForInflue({
          variables: {
            data: {
              commission: parseFloat(preData?.commission),
              infulancer: selectedOption?.value,
              shop_name: selectedOption?.label,
              note: preData?.note,
              shop: shopId,
              type: "NORMAL",
            },
          },
        });

        if (res) {
          addToast("ສ້າງລິ້ງສຳລັບອິນຟຣູ ສຳເລັດແລ້ວ!", {
            appearance: "success",
            autoDismiss: true,
          });
          hanldeClose();
          fetchcommissionData();
          setPreData({
            commission: "",
            note: "",
          });
          setSelectedOption(null);
        }
      }

      // console.log("preData55----->", preData, selectedOption);
    } catch (error) {
      console.log("error:-->", error);
    }
  };

  return (
    <Modal show={showForm.show} onHide={hanldeClose}>
      <Modal.Header closeButton>
        <Modal.Title>ສ້າງລິ້ງ ອາຟຣິລີເອດ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleCreateLinkInfluencer}>
          <Form.Group className="mb-1">
            <Form.Label>ເລືອກຊື່ອາຟຣິລີເອດ (ບັງຄັບ)</Form.Label>

            <Select
              value={selectedOption}
              onChange={handleChange}
              options={options}
              placeholder="ຄົ້ນຫາຊື່ອາຟຣິລີເອດ...."
            />
          </Form.Group>

          <Form.Group className="mb-1">
            <Form.Label>ກຳນົດຄ່າຄອມມິດຊັ່ນ *</Form.Label>
            <NumberFormat
              name="commission"
              className="form-control"
              onChange={(e) => {
                setPreData({
                  ...preData,
                  commission: e?.target?.value,
                });
              }}
              // onBlur={handleBlur}
              value={preData?.commission ?? ""}
              placeholder="0"
              thousandSeparator={true}
              prefix={""}
            />
          </Form.Group>

          <Form.Group className="mb-1">
            <Form.Label>ໝາຍເຫດ</Form.Label>
            <Form.Control
              name="note"
              values={preData?.note ?? ""}
              onChange={(e) => {
                setPreData({
                  ...preData,
                  note: e?.target?.value,
                });
              }}
              as="textarea"
              placeholder="Placeholder"
              rows={3}
            />
          </Form.Group>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 5,
              marginTop: 10,
            }}>
            <Button
              style={{
                background: "#eee",
                color: "gray",
                border: "none",
              }}
              onClick={hanldeClose}>
              ຍົກເລິກ
            </Button>
            <Button type="submit" style={{ background: COLOR_APP }}>
              ສ້າງລິ້ງ
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

// Define PropTypes
InfulancerForm.propTypes = {
  showForm: PropTypes.object.isRequired, // Define the type for showForm
  handleClose: PropTypes.func.isRequired, // Define the type for handleClose
};

export default InfulancerForm;
